<template>
  
  <v-col v-if="loadinDatos==true" class="text-center" cols="12">
            <v-skeleton-loader type="image" />
  </v-col>   
  <v-col v-else cols="12">
     
   <v-chart v-if="loadinDatos==false&&(tipoGrafico==1)" class="chart" :option="option" />
<wordcloud  v-else-if="loadinDatos==false&&tipoGrafico==2"
      :data="defaultWords"
      nameKey="name"
      valueKey="value"
      :rotate="rotate"
      :wordClick="wordClickHandler"
      color="Accent">
      
      </wordcloud>
  </v-col>
</template>

<script>
import { use } from "echarts/core";
import IEcharts from 'echarts'
import 'echarts/lib/chart/bar'
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { BarChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { ref, defineComponent } from "vue";
import wordcloud from 'vue-wordcloud'
use([
  CanvasRenderer,
  PieChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

export default({
  name: "IndicadoresRegional",
  components: {
    VChart,
    wordcloud
  },
  props: {
    idEncuesta: {
      type: Number,
      required: true,
    },
   
    loadingProp: {
      type: Boolean,
      default: false
    },
    lstIndicadoresRegional: {
      type: Array,
      default: function () {
        return []
      }
    },
    fnSetIndicadores: {
      type: Function,
      default: () => {}
    },
  },
   provide: {
    [THEME_KEY]: "white"
  },
   data () {
    return {
    loadinDatos:true,
    tipoGrafico:"",
 rotate: { from: 0, to: 0 },
  myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],
      defaultWords: [],

   option : {
  tooltip: {
    trigger: 'item'
  },
  legend: {
    orient: 'vertical',
    left: 'left'
  },
  series: [
    {
      type: 'pie',
      radius: '50%',
      data: [
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
},
 option2 : {
 tooltip: {
          trigger: "axis"
        },
        color: "#5DADE2",
        xAxis:{
          type: "category",
            data:[],
            show :true,
             axisLabel: {
      show: true,
      rotate: 48,
      fontSize: 10
      //interval: 6
    }
        },
        yAxis:{

        },
        series:[{
           
            type:'bar',
            barWidth: "60%",
            data:[],
            show : true
        }]      
},
   
    
    };
  },
beforeMount () { 
  },
  async mounted () {
    this.getEncuestaIndicadores();
    this.wordClickHandler();
  },
  methods: {
    getEncuestaIndicadores () {
       if(this.lstIndicadoresRegional.length>10){
          this.tipoGrafico=2;  
          }
          else{
            this.tipoGrafico=1;
          }
      
          for (var i=0; i<this.lstIndicadoresRegional.length; i++) {
            //if(this.tipoGrafico==2||this.tipoGrafico==3||this.tipoGrafico==6||this.tipoGrafico==4){
            if(this.tipoGrafico==1){
           this.option.series[0].data.push({value:this.lstIndicadoresRegional[i]["Cantidad"],name:this.lstIndicadoresRegional[i]["ESTADO"]+ " : " +this.lstIndicadoresRegional[i]["CIUDAD"]});
           }
            if(this.tipoGrafico==2){
             this.defaultWords.push({name:this.lstIndicadoresRegional[i]["CIUDAD"], value:this.lstIndicadoresRegional[i]["Cantidad"]});
         }
           }
            this.loadinDatos=false;
   },
    wordClickHandler(name, value) {
      name = this.name;
      value = this.value;
    },
  }
});
</script>

<style scoped>
.chart {
  height: 100vh;
}
</style>

<style>
body {
  margin: 0;
}
</style>
<style lang="scss">
div.tooltip {
  background-color: green !important;
  color: red !important;
}
</style>